import { createContext, useCallback, useState } from 'react';

import { Layout } from 'app/components';
import { HeadingProps } from 'utils/hooks/usePageHeading';

export interface ILayoutContext extends HeadingProps {
  heading: string;
  setHeading: (heading: string) => void;
  headingLogo: string;
  setHeadingLogo: (headingLogo: string) => void;
  resetHeading: () => void;
  headingProps: { back: string };
  setHeadingProps: (headingProps: { back: string }) => void;
  mobilePadding: boolean;
  setMobilePadding: (value: boolean) => void;
  desktopOnly: boolean;
  setDesktopOnly: (value: boolean) => void;
  className: string | undefined;
  setClassName: (value: string) => void;
  withoutLayout: boolean;
  setWithoutLayout: (value: boolean) => void;
}

export const LayoutContext = createContext<ILayoutContext | null>(null);

export const LayoutProvider = ({ children }) => {
  const [heading, setHeading] = useState('');
  const [headingLogo, setHeadingLogo] = useState('');
  const [headingProps, setHeadingProps] = useState({
    back: ''
  });
  const [mobilePadding, setMobilePadding] = useState(true);
  const [desktopOnly, setDesktopOnly] = useState(false);
  const [className, setClassName] = useState<string | undefined>(undefined);
  const [withoutLayout, setWithoutLayout] = useState(false);
  const resetHeading = useCallback(() => {
    setHeading('');
    setHeadingLogo('');
    setHeadingProps({
      back: ''
    });
    setMobilePadding(true);
    setDesktopOnly(false);
    setClassName(undefined);
    setWithoutLayout(false);
  }, []);

  return (
    <LayoutContext.Provider
      value={{
        heading,
        setHeading,
        headingLogo,
        setHeadingLogo,
        resetHeading,
        headingProps,
        setHeadingProps,
        mobilePadding,
        setMobilePadding,
        desktopOnly,
        setDesktopOnly,
        className,
        setClassName,
        withoutLayout,
        setWithoutLayout
      }}
    >
      <Layout>{children}</Layout>
    </LayoutContext.Provider>
  );
};

export default LayoutContext;
